import { ArrowPathIcon } from "@heroicons/react/20/solid";
import { format, formatDistanceStrict } from "date-fns";

import Button from "../../components/atomic/Button";
import { Heading } from "../../components/atomic/Heading";

import { NotesProps } from "./interface";
import { getValuesForNote } from "./utils";

export default function NotesTab<T extends boolean>(props: NotesProps<T>) {
  const {
    href,
    notes = [],
    whiteLabelStyle = {},
    isLenderPlatform,
    link,
  } = props;

  const Link = link;

  return (
    <div className="px-4">
      <div className="flex items-center">
        <Heading
          name="Notes"
          whiteLabelStyle={whiteLabelStyle}
        />

        {!!href && (
          <Link to={href}>
            <Button
              outline
              title="Refresh Bank Statements"
              className="flex items-center text-xs text-gray-500 ml-4 !border-0 !p-1"
            >
              <ArrowPathIcon className="w-4 h-4 text-inherit" />
            </Button>
          </Link>
        )}
      </div>
      <div className="mt-8">
        {notes?.map((note, indx: number) => {
          const { createdBy, userGroup, noteText, createdAt } =
            getValuesForNote(note, isLenderPlatform);

          return (
            <div
              key={indx}
              className="border border-gray-200 p-4 rounded-lg mb-2"
            >
              <div className="flex flex-col justify-center">
                <div className="flex items-center justify-between">
                  <div className="flex">
                    <p
                      className="text-[12px]"
                      id="created-by"
                    >
                      {createdBy}
                    </p>
                    {userGroup && (
                      <>
                        <span className="text-gray-600 text-[12px] mx-2">
                          •
                        </span>
                        <p
                          className="text-[12px] text-gray-600"
                          id="user-group"
                        >
                          {userGroup}
                        </p>
                      </>
                    )}
                  </div>
                  <p
                    className="text-[12px] text-gray-600"
                    title={format(createdAt, "dd MMM, yyyy - hh:mm aa")}
                    id="created-at"
                  >
                    {formatDistanceStrict(new Date(), createdAt)
                      .replace("minute", "min")
                      .replace("minutes", "mins")}{" "}
                    ago
                  </p>
                </div>

                <div className="notes-container mt-4">
                  <div
                    className="notes-content editor-style-container text-xs"
                    id="note-text"
                    dangerouslySetInnerHTML={{ __html: noteText }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
